import { VideoContainer } from '@coolblue-development/freddy';
export const Video = VideoContainer;
//# sourceMappingURL=Video.js.map